import script from "./ssmoodStudy3.vue?vue&type=script&setup=true&lang=js"
export * from "./ssmoodStudy3.vue?vue&type=script&setup=true&lang=js"

import "./ssmoodStudy3.vue?vue&type=style&index=0&id=1a19fedb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a19fedb"]])

export default __exports__